module.exports = __webpack_public_path__ + "static/media/lightbulb-on.bf89c5c0.svg";